import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

let onUnauthorized = null;
export const setUnauthorizedHandler = (fn) => { onUnauthorized = fn; };

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const url = error.config?.url || "";
    if (error.response?.status === 401 && !url.startsWith("/auth/") && !url.startsWith("/public/")) {
      onUnauthorized?.();
    }
    if (error.response?.status === 403 && error.response.data) {
      error.response.data.detail = forbiddenMessage(error.response.data.detail);
    }
    return Promise.reject(error);
  }
);

const SECTION_NAMES = { calendar: "Calendario", bookings: "Prenotazioni", guests: "Ospiti", rooms: "Camere", cleaning: "Pulizie", exports: "Schedine & ISTAT", invoices: "Fatture & Ricevute", reports: "Report Incassi", auditorium: "Calendario Auditorium", mensa: "Mensa" };

export function forbiddenMessage(detail) {
  if (detail && typeof detail === "object" && detail.code === "forbidden_section") {
    const names = (detail.sections || []).map((s) => SECTION_NAMES[s] || s);
    return `Permesso negato: il tuo account non è abilitato alla sezione ${names.join(" / ")}.`;
  }
  if (detail && typeof detail === "object" && detail.msg) return `Permesso negato: ${detail.msg.toLowerCase()}.`;
  if (typeof detail === "string") return `Permesso negato: ${detail}`;
  return "Permesso negato: questa azione non è abilitata per il tuo account.";
}

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;

export const loadError = (err) => {
  if (err?.response?.status === 401) return;
  import("sonner").then(({ toast }) => toast.error(formatApiError(err?.response?.data?.detail) || "Impossibile caricare i dati"));
};
